module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "main-section container"
  }, [_m(0), " ", _m(1), " ", _m(2), " ", _h('form', {
    staticClass: "form-inline"
  }, [_h('div', {
    staticClass: "form-group"
  }, [_h('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (selectedCity),
      expression: "selectedCity"
    }],
    staticClass: "form-control cities",
    on: {
      "change": function($event) {
        selectedCity = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          return "_value" in o ? o._value : o.value
        })[0]
      }
    }
  }, [_l((cities), function(city) {
    return _h('option', {
      domProps: {
        "value": city
      }
    }, [_s(city)])
  })])]), " ", _h('div', {
    staticClass: "form-group"
  }, [_h('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (selectedDistrict),
      expression: "selectedDistrict"
    }],
    staticClass: "form-control districts",
    on: {
      "change": function($event) {
        selectedDistrict = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          return "_value" in o ? o._value : o.value
        })[0]
      }
    }
  }, [_l((districts), function(district) {
    return _h('option', {
      domProps: {
        "value": district
      }
    }, [_s(district)])
  })])])]), " ", _m(3), " ", (legislatorsInDistrict.length > 1) ? _h('div', {
    staticClass: "legislator-selector"
  }, [_h('p', ["\n      你的選區有 " + _s(legislatorsInDistrict.length) + " 位立委，請選擇：\n      "]), _h('form', {
    staticClass: "form-inline"
  }, [_h('div', {
    staticClass: "form-group"
  }, [_h('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (legislatorIndex),
      expression: "legislatorIndex"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        legislatorIndex = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          return "_value" in o ? o._value : o.value
        })[0]
      }
    }
  }, [_l((legislatorsInDistrict), function(legislator, index) {
    return _h('option', {
      domProps: {
        "value": index
      }
    }, [_s(legislator.name)])
  })])])]), " ", _m(4)]) : _e(), " ", _h('div', {
    staticClass: "legislator"
  }, [_h('div', {
    staticClass: "legislator-name"
  }, [_s(legislator.name)]), " ", _h('div', {
    staticClass: "legislator-phone"
  }, [_h('a', {
    attrs: {
      "href": 'tel:' + legislator.labTel
    }
  }, [_s(legislator.labTel)])])]), " ", (legislator.party && legislator.party !== '民主進步黨') ? _h('p', {
    staticClass: "no-phone"
  }, ["\n    你不需要打電話，他是 " + _s(legislator.party) + " 籍的立法委員\n  "]) : _e(), " ", (legislator.party === '民主進步黨') ? _h('div', {
    staticClass: "example"
  }, [_m(5), " ", _h('div', {
    attrs: {
      "contenteditable": ""
    }
  }, [_h('p', ["\n        你好，請問是 ", _h('strong', [_s(legislator.name)]), " 委員的辦公室嗎？我是 ", _h('strong', [_s(selectedDistrict)]), " 的選民，我對民進黨強勢通過 ", _m(6), " 版本的勞基法草案非常不滿。吳秉叡還說「如果反對民進黨版本勞基法草案，以後選舉可以不投民進黨」。\n      "]), " ", _h('p', ["\n        請告訴 ", _h('strong', [_s(legislator.name)]), " 委員，如果砍七天假的勞基法通過，我以後在七天假返還以前都不會投給 ", _h('strong', [_s(legislator.name)]), " 和民進黨。\n      "]), " ", _m(7)])]) : _e(), " ", _h('div', {
    staticClass: "comments"
  }, [_m(8), " ", _m(9), " ", _h('disqus', {
    attrs: {
      "shortname": "7holidays"
    }
  })]), " ", _m(10)])
}},staticRenderFns: [function (){with(this) {
  return _h('h1', ["打電話給立委來表達你對", _h('strong', ["砍七天假"]), "的不滿！"])
}},function (){with(this) {
  return _h('p', ["\n    民進黨執意要在一例一休法案中，實際偷渡", _h('strong', ["砍掉七天國定假日"]), "的修法，而吳秉叡更說出：「", _h('strong', ["反對民進黨版勞基法 將來選舉可不投民進黨"]), "」！既然這樣，大家來打電話給自己選區的立法委員，告訴他們如果不撤回 ", _h('strong', ["砍掉七天國定假日"]), " 的修法，以後的大小選舉就照吳秉叡委員說的再也不要支持民進黨了吧！\n  "])
}},function (){with(this) {
  return _h('h2', ["選擇你的選區"])
}},function (){with(this) {
  return _h('h2', ["你的選區立委是"])
}},function (){with(this) {
  return _h('p')
}},function (){with(this) {
  return _h('h2', ["參考通話內容（點選可編輯）"])
}},function (){with(this) {
  return _h('strong', ["砍七天假"])
}},function (){with(this) {
  return _h('p', ["\n        請委員認真考慮選民的意見，公開反對 ", _h('strong', ["砍七天假"]), " 勞基法修法。\n      "])
}},function (){with(this) {
  return _h('h2', ["剛打完電話？分享一下經驗吧！"])
}},function (){with(this) {
  return _h('p', ["\n      立委辦公室如何回應你呢？分享一下你的經驗或秘訣給其他朋友吧！\n    "])
}},function (){with(this) {
  return _h('div', {
    staticClass: "footer"
  }, [_h('a', {
    attrs: {
      "href": "https://github.com/7holidays/7holidays.github.io/issues",
      "target": "_blank"
    }
  }, ["回報臭蟲"]), " |\n    ", _h('a', {
    attrs: {
      "href": "https://github.com/7holidays/7holidays.github.io",
      "target": "_blank"
    }
  }, ["GitHub project"]), " |\n    ", _h('a', {
    attrs: {
      "href": "https://g0v.hackpad.com/ep/pad/static/t5nla4R4Dft",
      "target": "_blank"
    }
  }, ["資料來源：立委咖電喂"]), " |\n    ", _h('a', {
    attrs: {
      "href": "http://join.g0v.today/",
      "target": "_blank"
    }
  }, ["徵求更好的設計與文案，請加入 g0v 聊天室"])])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-80382e2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainSection.vue
// module id = 46
// module chunks = 2